import VerifyCodeOtp from './VerifyCodeOtp';

export default VerifyCodeOtp;
